import { useEffect, useState } from "react";

import authorImage from "../../assets/Asman_PIc-Copy.jpeg";
import titleImage from "../../assets/blog_images/PenetratingTesting/Title.png";
import benefitsImage from "../../assets/blog_images/PenetratingTesting/Benifts.png";
import toolsImage from "../../assets/blog_images/PenetratingTesting/Tools.png";
import whiteBoxImage from "../../assets/blog_images/PenetratingTesting/White Box Testing.png";
import approachesImage from "../../assets/blog_images/PenetratingTesting/Diffenret Apporches.png";

import sqlInjectionImage from "../../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionImage from "../../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

function PenetrationTesting() {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareModalOpen1, setShareModalOpen1] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "Penetration Testing";

    function handleScroll() {
      setShowBackToTop(window.scrollY > 300);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openWhatsAppChat() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const waMe = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;
    window.open(waMe, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encoded}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-x-hidden bg-white">
      <section className="w-full max-w-5xl px-4 py-10 mx-auto overflow-x-hidden bg-white">
        <article className="article post tag-hackthebox image-small">
          <header className="article-header gh-canvas">
            <div className="mb-2 article-tag post-card-tags">
              <span className="post-card-primary-tag">
                <a href="" className="text-blue-600">
                  PenetrationTesting
                </a>
              </span>
            </div>

            <h1 className="mb-4 text-4xl font-semibold article-title">
              Exploring the Key Types of Penetration Testing in Cybersecurity
            </h1>

            <p className="mb-3 text-lg text-gray-800 article-excerpt">
              In today’s rapidly evolving threat landscape, organizations must
              do more than just deploy firewalls and antivirus software—they
              need to think like attackers. That’s where penetration testing
              (pentesting) comes in.
            </p>

            <p className="mb-6 text-lg text-gray-800 article-excerpt">
              A penetration test emulates real-world attacker techniques to
              uncover vulnerabilities that may threaten the confidentiality,
              integrity, or availability of critical systems. By identifying and
              addressing these weaknesses proactively, organizations can
              strengthen their defenses and reduce the risk of exploitation.
            </p>

            {/* Article Author Info */}
            <div className="flex flex-col items-start justify-between mb-6 sm:flex-row sm:items-center">
              {/* Left Section */}
              <div className="flex items-start gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={authorImage}
                  alt="Asman"
                />

                <div>
                  <h4 className="text-lg font-semibold">
                    <a href="">Asman</a>
                  </h4>

                  <div className="text-sm font-medium text-gray-500">
                    <time dateTime="2025-05-03">June 20, 2025</time>
                    <span className="ml-1">• 10 min read</span>
                  </div>
                </div>
              </div>

              {/* Right Section: Share Icon */}
              <button
                type="button"
                onClick={() => setShareModalOpen(true)}
                className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
              >
                {/* Share Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Share Modal */}
            {shareModalOpen && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
                onClick={(event) => {
                  if (event.target === event.currentTarget) {
                    setShareModalOpen(false);
                  }
                }}
              >
                <div className="p-6 text-black bg-gray-200 rounded-md w-80">
                  <h2 className="mb-4 text-lg font-semibold">
                    Share this article
                  </h2>

                  <div className="flex items-center justify-around">
                    {/* X / Twitter */}
                    <a
                      href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-500"
                    >
                      <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                      </svg>
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-700"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                      </svg>
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                      </svg>
                    </a>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShareModalOpen(false)}
                    className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <figure className="mb-6 article-image">
              <img
                src={titleImage}
                alt="PenetrationTesting Title"
                className="w-full rounded-lg lg:h-[750px]"
              />
            </figure>
          </header>

          <p className="mb-3 text-lg text-gray-800 article-excerpt">
            The scope of a pentest varies depending on specific goals. Some
            tests focus on external infrastructure—such as internet-facing
            servers and services—while others dive into internal corporate
            networks, web applications, APIs, or mobile environments. Each type
            offers a unique lens into the organization’s security posture.
          </p>

          <p className="mb-6 text-lg text-gray-800 article-excerpt">
            In this article, we’ll explore the different types of penetration
            testing, when they’re used, and why each one plays a vital role in
            protecting modern digital assets.
          </p>

          <section className="gh-content gh-canvas">
            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Penetration Testing: Staying Legal and Ethical
            </h2>

            <p className="mb-4 text-lg">
              Penetration testers must operate within ethical boundaries,
              securing written authorization and following clearly defined rules
              of engagement. Non-disclosure agreements (NDAs) safeguard the
              interests of both the client and the tester. Since legal
              requirements and compliance standards differ across regions, it's
              crucial to verify what activities are legally permitted before
              beginning any assessment.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              The Role of Penetration Testing
            </h2>

            <p className="mb-4 text-lg">
              Penetration testing plays a crucial role in a comprehensive
              security program by revealing how vulnerabilities can be exploited
              in real-world scenarios. It complements other practices like
              vulnerability scanning, code reviews, and compliance audits.
              Pentest results help assess risk more accurately, verify the
              effectiveness of security patches, and support informed
              decision-making for future security investments.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={benefitsImage}
                alt="PenetrationTesting Benifts"
                className="w-full rounded-lg lg:h-[700px]"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-4xl font-semibold">
              Different Types of Penetration Testing
            </h2>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              1. Web application penetration testing:
            </h2>

            <p className="mb-4 text-lg">
              Web Application Penetration Testing is a critical process in
              identifying and exploiting vulnerabilities within web applications
              to assess their security posture. This type of testing simulated
              real-world attacks to uncover weakness such as SQL Injection,
              Cross-Site Scripting (XSS), Local File Inclusion (LFI), and others
              that could be exploited by malicious attacks. Penetration tester
              use a combination of automated tools and manual techniques to
              probe the application for vulnerabilities, validate their impact,
              and suggest mitigation strategies. By performing these tests,
              organizations can identify potential security flaws before they are
              exploited by attackers, ensuring the integrity and confidentiality
              of sensitive data and safeguarding the application from future
              threats.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-bold">
              Most common attacks in web applications
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Broken access control</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Cryptographic failures</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Injection flaws (XSS, SQL, SSTI, etc.)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure design</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Security misconfiguration</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Vulnerable and outdated components</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Identification and authentication failures</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Software and data integrity failures</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Lack of logging and monitoring</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Server-Side Request Forgery (SSRF) vulnerabilities</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              2. Mobile penetration testing:
            </h2>

            <p className="mb-2 text-lg">
              A mobile application penetration test includes a static analysis
              and a dynamic analysis of the application, in addition to the tests
              carried out on the servers and, possibly, the APIs.
            </p>

            <p className="mb-2 text-lg">
              On the one hand, static analysis involves extracting elements
              (meta-information and source code, for example) to carry out
              reverse engineering attempts. On the other hand, dynamic analysis
              involves looking for vulnerabilities in the application during use
              (runtime). In general, in the event of misconfiguration or faulty
              implementation, it is possible to bypass controls or extract data.
            </p>

            <p className="mb-4 text-lg">
              As there is a steady growth in mobile devices, Android and iOS
              penetration testing is carried out in a streamlined manner. The
              app’s functionality is disrupted or access to sensitive data is
              gained through this testing method.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-bold">
              Most common attacks in Mobile penetration testing
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Improper Credential Usage</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Inadequate Supply Chain Security</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Authentication/Authorization</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insufficient Input/Output Validation</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Communication</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Inadequate Privacy Controls</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insufficient Binary Protections</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Security Misconfiguration</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Data Storage</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insufficient Cryptography</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              3. API penetration testing:
            </h2>

            <p className="mb-4 text-lg">
              An API (Application Programming Interface) is a set of rules that
              allows different software systems to talk to each other and share
              data. API testing involves checking how the API functions, whether
              it can be misused, and if security features like authentication
              and authorization can be bypassed. Testers also look for issues
              like command injection or SQL injections, and whether the API
              responses display sensitive data on a web page. The goal is to
              find any security weaknesses in the API itself or how it is used in
              an application.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-bold">
              Most common attacks in API penetration testing
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Broken Object Level Authorization (BOLA)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Broken Authentication</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Broken Object Property Level Authorization (BOPLA)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Unrestricted Resource Consumption</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Broken Function Level Authorization</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Unrestricted Access to Sensitive Business Flows</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Server Side Request Forgery (SSRF)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Security Misconfiguration</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Improper Inventory Management</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Unsafe Consumption of APIs</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              4. Network penetration testing:
            </h2>

            <p className="mb-2 text-lg">
              Network penetration testing uncovers security weaknesses in
              network infrastructure—such as firewalls, switches, routers—and
              endpoint devices. It helps prevent threats like firewall
              misconfigurations, attacks on network devices, DNS exploits, proxy
              abuse, and man-in-the-middle (MiTM) attacks.
            </p>

            <p className="mb-4 text-lg">
              These tests involve techniques like port scanning, system
              fingerprinting, configuration analysis, malware and virus
              detection, and traffic fuzzing and known vulnerable component
              exploitation.
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-bold">
              Most common attacks in Network penetration testing
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Open Ports & Unfiltered Services</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Default Credentials / Weak Passwords</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Unpatched Software & OS Vulnerabilities</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Misconfigured Firewalls & ACLs</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Lack of Network Segmentation</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Unencrypted Protocols</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>DNS and DHCP Attacks</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>SNMP Enumeration & Misconfigurations</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Man-in-the-Middle (MitM) Opportunities</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>SMB/NetBIOS Issues</strong>
              </li>
            </ul>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              5. Thick Client penetration testing:
            </h2>

            <p className="mb-2 text-lg">
              Thick client applications, also known as desktop applications, are
              fully functional computing systems that operate independently
              while connected to a network. Unlike thin clients, which rely
              heavily on a central server and often lack features like local
              storage, thick clients can function with or without network
              connectivity. Thick client penetration testing is the process of
              evaluating the security of these applications by identifying
              vulnerabilities, testing authentication controls, analyzing data
              encryption, checking for misconfigurations, and inspecting network
              communication. The goal is to ensure the application is secure,
              robust, and resistant to potential threats.
            </p>

            <p className="mb-4 text-lg">
              <strong>
                Few examples of thick client applications are Spotify, outlook,
                ERP Software, skype, Notepad++, Firefox.
              </strong>
            </p>

            <h2 id="network-scan" className="mb-4 text-2xl font-bold">
              Most common attacks in Think Client penetration testing
            </h2>

            <ul className="mb-4 space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6 text-lg">
                <strong>Improper Authentication & Authorization</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Data Storage</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Deserialization</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Communication (Lack of Encryption / TLS)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Reverse Engineering & Binary Manipulation</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>
                  Unvalidated Input / Injection Attacks (SQLi, Command
                  Injection, etc.)
                </strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Insecure Inter-Process Communication (IPC)</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Business Logic Vulnerabilities</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Security Misconfigurations</strong>
              </li>
              <li className="ml-6 text-lg">
                <strong>Use of Vulnerable Third-Party Components</strong>
              </li>
            </ul>

            <figure className="mb-6 article-image">
              <img
                src={toolsImage}
                alt="PenetrationTesting Tools"
                className="w-full rounded-lg lg:h-[700px]"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-4xl font-semibold">
              Penetration Testing Approaches
            </h2>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              1. White Box Testing
            </h2>

            <p className="mb-2 text-lg">
              White Box Testing is a software testing technique where the tester
              has full access to the application's internal code, logic, and
              architecture. It allows security professionals and developers to
              design test cases based on how the system is built, making it
              ideal for uncovering vulnerabilities like logic flaws, insecure
              data handling, and broken authentication mechanisms.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={whiteBoxImage}
                alt="PenetrationTesting white box tools"
                className="w-full rounded-lg lg:h-[700px]"
              />
            </figure>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              2. Black Box Testing
            </h2>

            <p className="mb-2 text-lg">
              Black box tests are done without knowing or understanding the
              internal mechanism of the software. Black box testing is the most
              widely used testing method. The tester does not know the software
              and designs the test as an uninformed attacker. Black box testing
              focuses on the functionality of the software. It is usually done
              at the requirements or specification level.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              3. Grey Box Testing
            </h2>

            <p className="mb-2 text-lg">
              Often enough, a web application involves authentication and
              authorization components. To be able to test these, we request for
              a dummy user account with the least level of privileges within the
              application. Using this account, we can log in and test for
              various flaws in the authentication scheme, as well as attempt to
              escalate our privileges and bypass authorization restrictions.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={approachesImage}
                alt="PenetrationTesting different Approaches"
                className="w-full rounded-lg lg:h-[700px]"
              />
            </figure>
          </section>
        </article>

        {/* Right Section: Share Icon */}
        <button
          type="button"
          onClick={() => setShareModalOpen1(true)}
          className="mt-10 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
        >
          {/* Share Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </section>

      {/* Share Modal */}
      {shareModalOpen1 && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
          onClick={(event) => {
            if (event.target === event.currentTarget) {
              setShareModalOpen1(false);
            }
          }}
        >
          <div className="p-6 text-black bg-gray-200 rounded-md w-80">
            <h2 className="mb-4 text-lg font-semibold">Share this article</h2>

            <div className="flex items-center justify-around">
              {/* X / Twitter */}
              <a
                href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-700"
              >
                <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-600"
              >
                <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                  <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                </svg>
              </a>
            </div>

            <button
              type="button"
              onClick={() => setShareModalOpen1(false)}
              className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Author Section */}
      <section className="max-w-5xl px-4 py-6 mx-auto mt-10 overflow-x-hidden rounded-lg">
        <div className="flex flex-col items-start gap-6 sm:flex-row">
          {/* Author Image */}
          <img
            src={authorImage}
            alt="Asman"
            className="object-cover w-24 h-24 rounded-lg"
          />

          {/* Author Info */}
          <div>
            <h3 className="mb-2 text-2xl font-semibold">Written by Asman</h3>

            <p className="mb-3 text-gray-700">Offensive Security Researcher.</p>

            <p className="text-gray-500 text-md">
              Published on <time dateTime="2023-02-11">June 20, 2025</time> •
              10 min read
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 text-black bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-4 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a href="sql-injection" target="_blank" rel="noopener noreferrer">
                  <img
                    className="object-cover w-full h-48"
                    src={sqlInjectionImage}
                    alt="SQL Injection"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Understanding SQL Injection: A Web Security Threat
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    SQL Injection is a critical security flaw that allows
                    attackers to manipulate SQL queries, risking data breaches or
                    full database control.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 03, 2025</span>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 2 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="OWASPTop10"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="broken-access-control-authentication"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={brokenAccessImage}
                    alt="Broken Access Control Authentication"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">OWASPTop10</div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Broken Access Control & Auth: A Security Breakdown
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Broken Access Control and Authentication vulnerabilities are
                    critical security flaws that allow unauthorized users to gain
                    access to restricted areas.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 02, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="session-management"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={sessionImage}
                    alt="Session Management"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Secure Session Management: Best Practices & Techniques
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Session management is secure for user authentication in web
                    applications. Techniques to prevent session-related threats
                    like hijacking and fixation.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>Apr 28, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Repeat your blog cards here (already responsive) */}
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setWhatsappOpen((prev) => !prev);
        }}
        className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 animate-blink hover:opacity-90 bg-gradient-to-r from-green-400 via-green-500 to-green-600"
        aria-label="Join WhatsApp"
      >
        <i className="text-4xl fa-brands fa-whatsapp"></i>
      </button>

      {/* WhatsApp Modal */}
      {whatsappOpen && (
        <div
          className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72 max-sm:right-4 max-sm:left-4 max-sm:w-auto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsappTitle"
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setWhatsappOpen(false);
            }}
            className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
            aria-label="Close"
          >
            &times;
          </button>

          <h2
            id="whatsappTitle"
            className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
          >
            Unsure about which course to choose?
          </h2>

          <p className="mb-3 text-sm text-center text-gray-700">
            Tap below to start a WhatsApp chat — we're here to help!
          </p>

          {/* Action buttons */}
          <div className="flex flex-col items-center gap-3">
            {/* Chat Now (wa.me URL works on mobile + desktop) */}
            <button
              type="button"
              onClick={openWhatsAppChat}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
              aria-label="Chat Now on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </button>

            {/* Open in App (deep link) */}
            <button
              type="button"
              onClick={openWhatsAppAppFallback}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
              aria-label="Open in WhatsApp App"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
              </svg>
              Open in App
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-700"
          aria-label="Back to top"
        >
          {/* Up Arrow Icon */}
          <i className="text-xl fa-solid fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Call Button */}
      <a
        href="tel:+91-9080432374"
        className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
        aria-label="Call Us"
      >
        {/* Phone Icon */}
        <i className="text-2xl fa-solid fa-phone"></i>
      </a>
    </main>
  );
}

export default PenetrationTesting;